import * as Yup from 'yup'

const productValidationSchema = Yup.object().shape({
  code: Yup.string()
    .required('Le code est requis')
    .oneOf(['PRD', 'SEV'], "Le code doit être soit 'PRD' soit 'SEV'"),
  label: Yup.string().required('Le libellé est obligatoire'),
  // description: Yup.string()
  //   .optional()
  //   .max(255, 'La description doit comporter au maximum 255 caractères'),
  price: Yup.number().optional().min(0, 'Le prix doit être un nombre supérieur ou égal à 0'),
  quantity: Yup.number().optional().min(0, 'La quantité doit être un entier supérieur ou égal à 0'),
  minStock: Yup.number()
    .optional()
    .min(0, 'Le stock minimum doit être un entier supérieur ou égal à 0')
    .test('is-more', 'Le stock maximum doit être supérieur au stock minimum', (value, context) => {
      if (!context.parent.maxStock) return true
      if (!value) return true
      return value <= context.parent.maxStock
    }),
  maxStock: Yup.number()
    .optional()
    .min(0, 'Le stock maximum doit être un entier supérieur ou égal à 0')
    .test('is-less', 'Le stock maximum doit être supérieur au stock minimum', (value, context) => {
      if (!context.parent.minStock) return true
      if (!value) return true
      return value >= context.parent.minStock
    }),
  allowManufactureEmpty: Yup.boolean().optional(),
  sellPrice: Yup.number()
    .optional()
    .min(0, 'Le prix de vente doit être un nombre supérieur ou égal à 0'),
  sellingTva: Yup.number()
    .optional()
    .min(0, 'La TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  sellingTvaTwo: Yup.number()
    .optional()
    .min(0, 'La deuxième TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  sellingTvaThree: Yup.number()
    .optional()
    .min(0, 'La troisième TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  buyingTva: Yup.number()
    .optional()
    .min(0, 'La TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  buyingTvaTwo: Yup.number()
    .optional()
    .min(0, 'La deuxième TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  buyingTvaThree: Yup.number()
    .optional()
    .min(0, 'La troisième TVA de vente doit être un nombre supérieur ou égal à 0')
    .max(100, 'La TVA doit être inférieure ou égale à 100'),
  currency: Yup.string().optional(),
  priceType: Yup.string()
    .optional()
    .oneOf(['HT', 'TTC'], "Le type de prix doit être soit 'HT' soit 'TTC'"),
  sellPriceType: Yup.string()
    .optional()
    .oneOf(['HT', 'TTC'], "Le type de prix de vente doit être soit 'HT' soit 'TTC'"),
  barCode: Yup.string().optional(),
  unit: Yup.number().optional(),
  category: Yup.number().optional(),
  color: Yup.string().optional(),
})

const categoryValidationSchema = Yup.object().shape({
  name: Yup.string().required('Le nom de la catégorie est requis'),
})

const unitValidationSchema = Yup.object().shape({
  label: Yup.string().trim().required('Le libellé est requis'),
  code: Yup.string().trim().required('Le code est requis'),
})

export {productValidationSchema, categoryValidationSchema, unitValidationSchema}
